import { createTheme } from '@mui/material'

const andreaTheme = createTheme({
  palette: {
    background: {
      default: '#f9fafc',
      input: '#f4f6f9',
      paper: '#ffffff',
    },
    primary: {
      light: '#939ed5',
      main: '#3f51b5',
      dark: '#2c387e',
    },
  },
})

export default andreaTheme
